module.exports = __webpack_public_path__ + "img/1010.f96314d5.jpg";